import {
  Box,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material'
import React, { useState } from 'react'
import QRCode from 'react-qr-code'
import { ElectricBolt, SimCardDownload } from '@mui/icons-material'

function ModalModeSwitch() {
  const [openMode, setOpenMode] = useState(false)
  const [memory, setMemory] = useState(false)
  return (
    <>
      <Button
        variant={'outlined'}
        startIcon={<SimCardDownload />}
        color={'info'}
        onClick={() => setOpenMode(true)}
      >
        Mode
      </Button>
      <Dialog open={openMode}>
        <DialogTitle>Scan to switch the interaction mode</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <ButtonGroup sx={{ mt: 1 / 2, mr: 1 }}>
              <Button
                onClick={() => setMemory(true)}
                disabled={memory}
                variant={memory ? 'contained' : 'outlined'}
                size={'small'}
              >
                <Stack alignItems={'center'}>
                  <SimCardDownload />
                  Memory
                </Stack>
              </Button>
              <Button
                onClick={() => setMemory(false)}
                disabled={!memory}
                variant={!memory ? 'contained' : 'outlined'}
                size={'small'}
              >
                <Stack alignItems={'center'}>
                  <ElectricBolt />
                  Immediate
                </Stack>
              </Button>
            </ButtonGroup>
            <QRCode
              size={100}
              style={{ height: '100px', width: '100px' }}
              value={`%%SpecCode${memory ? '11' : '10'}|${memory ? 'C2' : 'C0'}`}
              viewBox={`0 0 256 256`}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenMode(false)
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ModalModeSwitch
